import { render, staticRenderFns } from "./ImageZoomer.vue?vue&type=template&id=357c6502&scoped=true"
import script from "./ImageZoomer.vue?vue&type=script&lang=ts"
export * from "./ImageZoomer.vue?vue&type=script&lang=ts"
import style0 from "./ImageZoomer.vue?vue&type=style&index=0&id=357c6502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c6502",
  null
  
)

export default component.exports